import React from 'react'

export default function PrettyViewObject({ data }) {
  return (
    <div className='bg-gray-900 text-gray-100 font-mono p-4 rounded-lg text-[12px]'>
      {Object.entries(data).map(([key, value]) => (
        <div key={key} className='mb-1 flex'>
          <span className='text-blue-400'>{key}</span>
          <span className='text-gray-400'> = </span>
          <span className='text-green-300'>{value}</span>
        </div>
      ))}
    </div>
  )
}
